import { render, staticRenderFns } from "./modalsContainer.vue?vue&type=template&id=4087d636&scoped=true&"
import script from "./modalsContainer.vue?vue&type=script&lang=ts&"
export * from "./modalsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./modalsContainer.vue?vue&type=style&index=0&id=4087d636&prod&scoped=true&lang=css&"
import style1 from "./modalsContainer.vue?vue&type=style&index=1&id=4087d636&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4087d636",
  null
  
)

export default component.exports